export default () => {
  const domNode = dom.querySelector(".homepage__header_imagePlaceholder");

  if (domNode !== null) {
    import("./index" /* webpackChunkName: "homepage-background-image" */).then(
      ({ default: startApp }) => {
        startApp(domNode);
      }
    );
  }
};
